/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'fm-ghost-element',
  templateUrl: './ghost-element.component.html',
  styleUrls: ['./ghost-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GhostElementComponent implements OnInit {
  constructor(private readonly _renderer: Renderer2, private readonly _el: ElementRef) {}

  ngOnInit() {
    const parent = (<HTMLElement>this._el.nativeElement).parentElement;
    this._renderer.setStyle(this._el.nativeElement, 'height', `${parent.clientHeight}px`);
    this._renderer.setStyle(this._el.nativeElement, 'width', `${parent.clientWidth}px`);
  }
}
